<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KEo50F/tc-custom/9780814720233.jpg?1728259194141" alt="This image is the cover for the book Daddy Grace, Religion, Race, and Ethnicity"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Daddy Grace, Religion, Race, and Ethnicity
      </h1>
      <p class="bookDescription body article font2">
        <p>Charles Manuel “Sweet Daddy” Grace founded the United House of Prayer for All People in Wareham, Massachusetts, in 1919. This charismatic church has been regarded as one of the most extreme Pentecostal sects in the country. In addition to attention-getting maneuvers such as wearing purple suits with glitzy jewelry, purchasing high profile real estate, and conducting baptisms in city streets with a fire hose, the flamboyant Grace reputedly accepted massive donations from his poverty-stricken followers and used the money to live lavishly. It was assumed by many that Grace was the charismatic glue that held his church together, and that once he was gone the institution would disintegrate. Instead, following his 1960 death there was a period of confusion, restructuring, and streamlining. Today the House of Prayer remains an active church with a national membership in the tens of thousands.<br/><b>Daddy Grace: A Celebrity Preacher and His House of Prayer</b> seriously examines the religious nature of the House of Prayer, the dimensions of Grace’s leadership strategies, and the connections between his often ostentatious acts and the intentional infrastructure of the House of Prayer. Furthermore, woven through the text are analyses of the race, class, and gender issues manifest in the House of Prayer structure under Grace’s aegis.<br/>Marie W. Dallam here offers both a religious history of the House of Prayer as an institution and an intellectual history of its colorful and enigmatic leader.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marie W Dallam
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New York University
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a6a8201a